module.exports = __webpack_public_path__ + "270101fbb967b462c1af44dabcf85db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/south-coast.jpg
// module id = 528
// module chunks = 0